import { render } from "./DeleteCorporatePlanComponent.vue?vue&type=template&id=0747c09a"
import script from "./DeleteCorporatePlanComponent.vue?vue&type=script&lang=js"
export * from "./DeleteCorporatePlanComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__